/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = environment.apiV2BaseUri;
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
